import InfoAudioLibro from './InfoAudioLibro';
import React from "react"
import './InfoAudioLibro.css'


const PageInfoAudioLibro = () => {
    return (
        <div className={"fondoImgIAL"}>
            <InfoAudioLibro></InfoAudioLibro>
        </div>

    )
}

export default PageInfoAudioLibro;